<h1 *ngIf="theme !== 'darkTheme'">
	<span [hidden]="!backOnMobile" (click)="goBack()" class="mobile-navigation"><i class="fa fa-arrow-left"></i></span>
	<span [hidden]="backOnMobile" (click)="showMobileMenu()" class="mobile-navigation"><i class="fa fa-bars"></i></span>
	<span *ngIf="icon" class="icon"><i class="{{ faIcon }} fa-{{ icon }}"></i></span>
	<span class="title" [ngClass]="{'filename': !title && filename}">{{ title || filename }} <ng-content select=".subtitle"></ng-content></span>
</h1>

<ng-content select=".bb-header-extra"></ng-content>
<ng-content select="bb-status"></ng-content>
<ng-content select=".buttons-wrapper"></ng-content>

<bb-filters
	[filterConfig]="filterConfig"
	[currentPath]="currentPath"
	[search]="search"
	[allowCustomPreset]="allowCustomPreset"
	[theme]="theme"
	[presetToggable]="presetToggable"
></bb-filters>

<div class="tabs-wrapper" [class.open]="tabsVisibleMobile" (click)="tabsVisibleMobile = !tabsVisibleMobile">
	<ng-content select=".tabs"></ng-content>
</div>
<div class="tabs-wrapper-dynamic" [class.open]="tabsVisibleMobile" (click)="tabsVisibleMobile = !tabsVisibleMobile">
	<div #tabs *ngIf="tabItems?.length" class="tabs">
		<ng-container *ngFor="let tabItem of tabItems">
			<div *ngIf="tabItem && !tabItem.hide" [class.root]="tabItem.root" routerLinkActive="containerActive" #tabChild>
				<a [routerLink]="inModal ? tabItem.modalRouterLink : tabItem.internalRouterLink" [ngClass]="{'active': tabItem.active}" [routerLinkActive]="tabItem.activeClass">
					<i class="fa fa-{{ tabItem.icon }}"></i> {{ tabItem.title }}
				</a>
			</div>
		</ng-container>
		<div *ngIf="verticalList?.length" class="dropdown-container" cdkOverlayOrigin #dropdown="cdkOverlayOrigin" (click)="showMore()">
			<a class="more" [class.active]="activeTabInList">
				<i _ngcontent-c13="" class="fas fa-caret-down"></i>
			</a>
		</div>
	</div>
</div>
